import { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setArticles } from "../../redux";

import { useInsertBoldTag } from "../../hooks/useInsertBoldTag";

import { LangContext } from "../../context/LangContext";
import { useGoPage } from "../../hooks/useGoPage";

import SelectLang from "../../components/SelectLang";
import Slider from "../../components/Slider";
import Selectors from "./Selectors";

import "./style.css"

import article_type_1 from '../../assets/svg/onglet_type_article_1.svg';
import article_type_2 from '../../assets/svg/onglet_type_article_2.svg';

function Article({ article }) {
    const goPage = useGoPage();
    const dispatch = useDispatch();
    const insertBoldTag = useInsertBoldTag();
    const [formData, setFormData] = useState(null);
    const [inSubmit, setInSubmit] = useState(false);
    const articlesData = useSelector(state => state.articles);
    const { language, translations } = useContext(LangContext);

    useEffect(() => {
        if (!article) {
            goPage('error');
            return
        }
        if (article === 'new') return
        setFormData(article);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [article]);

    const newArticle = (withSelector) => {
        let newForm = {
            title_fr: '',
            title_en: '',
            descrip_fr: '',
            descrip_en: '',
            images: [],
            price: '',
            quantity: '',
            weight: '',
        }

        if (withSelector) {
            newForm.category_fr = '';
            newForm.category_en = '';
            newForm.selectors = [{
                name_fr: '',
                name_en: '',
            }];
            newForm.multi_qty = false;
        }
        setFormData(newForm);
    }

    const setValue = (e, field) => {
        setFormData({
            ...formData,
            [field]: e.target.value
        })
    }

    const setNumValue = (e, field) => {
        let newValue = e.target.value;

        if (field === 'price') {
            // Supprime tout ce qui n'est pas un chiffre, un point (1 seul) et les zéros initiaux (sauf pour "0" ou "0.xx")
            newValue = newValue.replace(/[^0-9.]/g, '').replace(/^0+(?!\.|$)/, '');
            if (newValue !== '' && !/^[0-9]+(\.[0-9]{0,2})?$/.test(newValue)) return;
        }

        if (field === 'quantity') {
            newValue = newValue.replace(/[^0-9+-]/g, '');           // 1. garde chiffres et signes
            newValue = newValue.replace(/^([+-]?)[+-]*/, '$1');     // 2. un seul signe au début
            newValue = newValue.replace(/^0+(?=\d)/, '');           // 3. enlève les zéros initiaux sauf si "0" seul

            if (!/^[+-]?\d*$/.test(newValue)) return;               // 4. autorise "", "+", "-", "0", "123", "+123"…
        }

        setFormData({
            ...formData,
            [field]: newValue
        });
    };

    const filteredSelectors = () => {
        const response = [];

        for (const s of formData.selectors) {
            if (s.name_fr === '' && s.name_en === '') continue

            if (s.name_fr === '' || s.name_en === '') {
                return { error: "Attention il manque une traduction à l'une des catégorie" }
            }

            const quantityIsInvalid = s.quantity === '' || isNaN(s.quantity) || (!formData._id && s.quantity <= 0);

            if (formData.multi_qty === true && quantityIsInvalid) {
                return { error: "Quantité invalide" }
            }
            response.push(s);
        }
        return response
    }

    const submitForm = async (e) => {
        e.preventDefault();

        if (inSubmit) return alert("Chargement en cours, veuillez patienter");
        else setInSubmit(true);


        const body = new FormData();

        // --------------------------------------------------------------------
        // Title
        if (formData.title_fr === '' || formData.title_en === '') {
            alert("Titre requis pour l'ajout d'un article");
            setInSubmit(false);
            return
        }
        body.append('title_fr', formData.title_fr);
        body.append('title_en', formData.title_en);

        // --------------------------------------------------------------------
        // Descrip
        if (formData.descrip_fr === '' || formData.descrip_en === '') {
            alert("Description requis pour l'ajout d'un article");
            setInSubmit(false);
            return
        }
        body.append('descrip_fr', formData.descrip_fr);
        body.append('descrip_en', formData.descrip_en);

        // --------------------------------------------------------------------
        // Images
        if (!formData.images || formData.images.length === 0) {
            alert('Au moin une image est nécéssaire');
            setInSubmit(false);
            return
        }

        if (formData.images && Array.isArray(formData.images)) {
            // Envoyer d'abord l'ordre des images
            body.append('images_order', JSON.stringify(formData.images.map(img => ({
                type: img.file ? 'new' : 'existing',
                url: img.url || null,
                _url: img._url || null
            }))));

            // Ensuite envoyer les images
            formData.images.forEach((img, index) => {
                if (img.url && !img.file) {
                    // Image existante
                    body.append(`existing_images[${index}][url]`, img.url);
                    body.append(`existing_images[${index}][_url]`, img._url);
                }
                else if (img.file) {
                    // Nouvelle image
                    body.append('images', img.file);
                }
            });
        }

        // --------------------------------------------------------------------
        // Price
        if (formData.price === '' || parseFloat(formData.price) === 0) {
            alert("Prix requis pour l'ajout d'un article");
            setInSubmit(false);
            return
        }
        body.append('price', formData.price);

        // --------------------------------------------------------------------
        // Weight
        if (formData.weight === '' || parseFloat(formData.weight) === 0) {
            alert("Poid requis pour l'ajout d'un article");
            setInSubmit(false);
            return
        }
        body.append('weight', formData.weight);

        // --------------------------------------------------------------------
        // Uncategorized
        if (formData.selectors === undefined || formData.category_fr === undefined) {
            // --------------------------------------------------------------------
            // Quantity
            if (formData.quantity === '' || isNaN(formData.quantity) || (!formData._id && formData.quantity <= 0)) {
                alert("Quantité invalide");
                setInSubmit(false);
                return
            }
            body.append('quantity', formData.quantity);
        }
        // --------------------------------------------------------------------
        // Categorized
        else {
            // --------------------------------------------------------------------
            // Label selector
            if (formData.category_fr === '' || formData.category_en === '') {
                alert("Titre requis pour l'ajout d'un article");
                setInSubmit(false);
                return
            }

            body.append('category_fr', formData.category_fr);
            body.append('category_en', formData.category_en);

            // --------------------------------------------------------------------
            // Selectors
            const selectors = filteredSelectors();

            if (selectors.error || selectors.length === 0) {
                alert(selectors.error || "Données du selecteur manquantes");
                setInSubmit(false);
                return
            }

            body.append('selectors', JSON.stringify(selectors));
            body.append('multi_qty', formData.multi_qty);

            // --------------------------------------------------------------------
            // Quantity
            if (formData.multi_qty === false) {
                if (formData.quantity === '' || isNaN(formData.quantity) || (!formData._id && formData.quantity <= 0)) {
                    alert("Quantité invalide");
                    setInSubmit(false);
                    return
                }
                body.append('quantity', formData.quantity);
            }
        }

        const req = await fetch(`${process.env.REACT_APP_API_URL}/articles/${formData._id ? `edit/${formData._id}` : 'add'}`, {
            method: formData._id ? 'PUT' : 'POST',
            headers: { 'Authorization': `Bearer ${localStorage.getItem('token_vanrah')}` },
            body,
        });
        const res = await req.json();
        setInSubmit(false);

        if (req.status !== 201 && req.status !== 200) {
            alert(res.message);
            return
        }

        // Update db
        if (formData._id) {
            const newArticlesDb = articlesData.map(e => {
                if (e._id === formData._id) return res;
                return e;
            });
            dispatch(setArticles(newArticlesDb));
        }
        // Add db
        else {
            dispatch(setArticles([...articlesData, res]));
        }

        alert(`Article ${formData._id ? 'modifié' : 'ajouté'} avec succès !`);
        goPage('shop');
    }

    return !formData ? (
        <article className='page page_article'>
            <p className="title_page">- <span>Model du produit</span> -</p>

            <div className="selector_article_type">
                <button onClick={() => newArticle()}>
                    <img src={article_type_1} alt="" />
                    <p>Sans catégorie</p>
                </button>

                <button onClick={() => newArticle(true)}>
                    <img src={article_type_2} alt="" />
                    <p>Avec catégorie</p>
                </button>
            </div>
        </article>
    ) : (
        <form
            className='page page_article'
            onSubmit={(e) => submitForm(e)}
        >
            <button
                className="btn_return"
                onClick={() => goPage('shop')}
            >
                {'<'}-<span>{translations.return}</span>--
            </button>

            <p className='title_page'>
                - <input
                    type="text"
                    placeholder="Titre de l'article"

                    value={formData[`title_${language}`]}
                    onChange={(e) => setValue(e, `title_${language}`)}
                /> -
            </p>

            <SelectLang />

            <section className="sect_slider_descrip">
                <Slider images={formData.images} setImages={setFormData} />

                <div className="description">
                    <div className="textarea">
                        <span className="label">{translations.product_descrip} :</span>
                        
                        <div className="toolbar">
                            <button
                                type="button"
                                onClick={() => insertBoldTag('.page_article', formData, setFormData, language)}
                            >Gras</button>
                        </div>

                        <textarea
                            className="value"
                            value={formData[`descrip_${language}`]}
                            onChange={(e) => setValue(e, `descrip_${language}`)}
                            placeholder={`Description de la page en ${language === "fr" ? '"Français"' : '"Anglais"'}`}
                        ></textarea>
                    </div>

                    <div className="field">
                        <span>{translations.price} :</span>

                        <input
                            type="text"
                            placeholder="0.00€"
                            className="inp_price"

                            value={formData.price}
                            onChange={(e) => setNumValue(e, 'price')}
                        />
                    </div>

                    <Selectors formData={formData} setFormData={setFormData} />

                    <div className="container">
                        {!formData.multi_qty &&
                            <div className="field_qty">
                                <span>{translations.quantity} :</span>

                                <input
                                    type="text"
                                    inputMode="numeric"
                                    value={formData.quantity || ''}
                                    placeholder="0"
                                    onChange={(e) => formData.multi_qty !== true && setValue(e, 'quantity')}
                                />
                            </div>
                        }

                        <div className="field_weight">
                            <span>Poids :</span>

                            <input
                                type="text"
                                inputMode="numeric"
                                value={formData.weight || ''}
                                placeholder="1000 g"
                                onChange={(e) => setValue(e, 'weight')}
                            />
                        </div>

                        <button
                            type="submit"
                            className="btn_submit"
                        >{article === 'new' ? 'Ajouter' : 'Modifier'} le produit</button>
                    </div>
                </div>
            </section>
        </form>
    )
}

export default Article;